export default __webpack_public_path__ + "static/media/about.1f28e87b.jpg";